module.exports = __webpack_public_path__ + "static/media/darth-vader.c622f199.jpg";